import styled from "@emotion/styled";
import Label from "../label";
import { Colors } from "theme/colors";
import { css } from "@emotion/react";
import Icon from "components/icon";

interface ContainerProps {
  $hover: boolean;
  $disabled: boolean;
}

export const StyledContainer = styled.label<ContainerProps>`
  display: flex;
  align-self: flex-start;
  position: relative;
  padding-left: 2.06rem;
  align-items: flex-start;

  cursor: pointer;
  ${(props) =>
    props.$disabled &&
    css`
      cursor: default;
    `}

  font-size: 1.3rem;
  user-select: none;

  border-radius: 0.325rem;

  // hover styles
  ${(props) =>
    props.$hover &&
    css`
      input ~ span {
        background-color: ${Colors.LIGHT_GRAY};
      }
    `}
`;

interface InputProps {
  $focus: boolean;
}

export const StyledInput = styled.input<InputProps>`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;

  &:disabled {
    cursor: default;
  }

  &:checked ~ span {
  }

  &:checked ~ span:after {
    display: block;
  }

  ${(props) =>
    props.$focus &&
    css`
      & ~ span {
        border: 0.18rem solid ${Colors.MID_BLUE};
        background-color: ${Colors.WHITE};

        &:after {
          top: 0.12rem;
          left: 0.41rem;
        }
      }
    `}
`;

export const StyledLock = styled(Icon)`
  position: absolute;
  top: 0;
  left: 4px;
`;

export const StyledCheckmark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 1.5625rem;
  width: 1.5625rem;
  cursor: pointer;

  background-color: ${Colors.WHITE};
  border: 0.059rem solid ${Colors.MID_GRAY};
  box-shadow: 0 0.12rem 0.24rem 0 rgba(0, 0, 0, 0.2) inset;
  border-radius: 0.3125rem;

  &:after {
    content: "";
    position: absolute;
    display: none;
  }

  &:after {
    left: 0.53rem;
    top: 0.235rem;
    width: 0.411rem;
    height: 0.7rem;
    border: solid ${Colors.BLUE};
    border-width: 0 0.12rem 0.12rem 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;

export const StyledLabel = styled(Label)`
  user-select: none;
  display: block;
  margin-top: 0.235rem;
  margin-bottom: 0;
  flex: 1;
`;
